import styled from "styled-components";

export const CardWrapper = styled.div`
  height: fit-content;
  width: 100%;
  min-width: 0;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const FirstColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const RowWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 2fr) 90px 120px 100px;
  align-items: center;
  width: 100%;
  gap: 12px 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const ColumnWrapper = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > *:first-child {
    white-space: nowrap;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 48px 0;
  width: 100%;
`;
